import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const IMG = "https://images.unsplash.com/photo-1767274101063-a735a6849afc";

export const Slide6 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={5} total={total} onActive={onActive} label="Phase 1">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: `url(${IMG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          opacity: 0.55,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-transparent" />

      <div className="relative z-10 flex flex-col h-full w-full max-w-7xl px-6 md:px-12">
        <div className="overline mb-8 shrink-0">{t.overline}</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 flex-1 items-end pb-12">
          <div className="lg:col-span-7 self-start">
            <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter mb-8">
              {t.heading}
            </h2>
            <p className="text-lg md:text-xl text-neutral-300 font-light leading-relaxed max-w-xl">
              {t.body}
            </p>
          </div>

          <div className="lg:col-span-5">
            <div className="glass-strong rounded-2xl p-8">
              <div className="flex items-baseline justify-between mb-6">
                <div className="font-display text-6xl md:text-7xl text-[var(--ph-accent)] leading-none">
                  500
                  <span className="text-2xl text-neutral-500">→</span>
                  1K
                </div>
              </div>
              <div className="font-mono text-[10px] tracking-widest text-neutral-500 mb-6">
                ACTIVE USERS · SAME ZONES
              </div>
              <div className="space-y-3">
                {t.tactics.map((tt, i) => (
                  <div
                    key={i}
                    className="flex justify-between items-center py-3 border-b border-white/5"
                    data-testid={`s6-tactic-${i}`}
                  >
                    <span className="font-mono text-[10px] tracking-widest text-neutral-500">
                      {tt.k.toUpperCase()}
                    </span>
                    <span className="text-sm text-neutral-200 text-right">{tt.v}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </SlideShell>
  );
};


